import { frenchDate as formatDate } from './frenchDate';

const safeName = value => String(value || 'releve').replace(/[^\p{L}\p{N}_-]+/gu, '_');

export async function downloadTimesheets(rows, week, year, format = 'zip') {
  if (!rows.length) return;
  const [{ jsPDF }, { default: autoTable }, { default: JSZip }, { saveAs }] = await Promise.all([
    import('jspdf'), import('jspdf-autotable'), import('jszip'), import('file-saver'),
  ]);
  const zip = new JSZip();
  const combined = format === 'pdf' ? new jsPDF() : null;
  rows.forEach((row, index) => {
    const pdf = combined || new jsPDF();
    if (combined && index > 0) pdf.addPage();
    pdf.setFontSize(18);
    pdf.text("Relevé d'heures", 14, 20);
    pdf.setFontSize(11);
    const details = [
      `Intérimaire : ${row.employeeName || '—'}`,
      `Client : ${row.clientName || '—'}`,
      `Contrat : ${row.contractNumber || '—'}`,
      `Période : ${formatDate(row.startDate)} au ${formatDate(row.endDate)}`,
    ];
    details.forEach((text, i) => pdf.text(pdf.splitTextToSize(text, 180), 14, 32 + i * 14));
    autoTable(pdf, {
      startY: 90,
      head: [['Jour', 'Heures de jour', 'Heures de nuit', 'Absence']],
      body: ['lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi', 'dimanche'].map(day => [
        day.charAt(0).toUpperCase() + day.slice(1), row.hours?.[day] ?? '', row.nightHours?.[day] ?? '', row.absences?.[day] ?? '',
      ]),
    });
    if (row.heures?.length) autoTable(pdf, {
      startY: pdf.lastAutoTable.finalY + 10, head: [["Type d'heures", 'Quantité']],
      body: row.heures.map(item => [item.type, item.quantite]),
    });
    if (row.primes?.length) autoTable(pdf, {
      startY: pdf.lastAutoTable.finalY + 10, head: [['Prime', 'Quantité']],
      body: row.primes.map(item => [item.type, item.quantite]),
    });
    if (!combined) zip.file(`${index + 1}_${safeName(row.employeeName)}_${safeName(row.id)}.pdf`, pdf.output('arraybuffer'));
  });
  if (combined) {
    saveAs(combined.output('blob'), `releves_semaine_${week}_${year}.pdf`);
    return;
  }
  saveAs(await zip.generateAsync({ type: 'blob' }), `releves_semaine_${week}_${year}.zip`);
}
